import { getColumnDefs } from '@components/StoreMonitoring/StoreDetailsPage/TabView/TankReadings/columnDefs'
import { GraviGrid, Vertical } from '@gravitate-js/excalibrr'
import { useUserSettings } from '@hooks/settings'
import React, { useMemo } from 'react'

export function TankReadings({ tankReadingData, isFetching, storeTimezone }) {
  const { updateSetting } = useUserSettings()
  const columnDefs = useMemo(() => getColumnDefs(storeTimezone), [storeTimezone])
  const agPropOverrides = useMemo(() => ({ getRowId: (row) => row?.data?._id }), [])

  return (
    <Vertical flex={1}>
      <GraviGrid
        controlBarProps={{
          title: 'Tank Readings',
        }}
        columnDefs={columnDefs}
        agPropOverrides={agPropOverrides}
        sideBar={false}
        loading={isFetching}
        rowGroupPanelShow='never'
        rowHeight={30}
        storageKey='tank-readings'
        rowData={tankReadingData}
        onGridConfigChanged={(config) => updateSetting('gridConfig::tank-readings', config)}
      />
    </Vertical>
  )
}
